"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Theme_1 = require("./Theme");
var react_router_dom_1 = require("react-router-dom");
var BaseButton = /** @class */ (function (_super) {
    __extends(BaseButton, _super);
    function BaseButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            doRedirect: false
        };
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    BaseButton.prototype.onClick = function () {
        if (this.props.to) {
            this.setState({ doRedirect: true });
        }
        else if (this.props.onClick) {
            this.props.onClick();
        }
        return null;
    };
    BaseButton.prototype.render = function () {
        if (this.state.doRedirect && this.props.to) {
            return React.createElement(react_router_dom_1.Redirect, { to: this.props.to });
        }
        return React.createElement(Theme_1.default, { color: this.props.color || "primary" }, this.renderButton());
    };
    return BaseButton;
}(React.Component));
exports.default = BaseButton;
//# sourceMappingURL=BaseButton.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/BaseButton.js
// module id = 1016
// module chunks = 0